import React, { useState } from 'react';
import { Routes, Route, Navigate, useNavigate } from 'react-router-dom';
import SignupForm from './components/Shared/authforms/SignupForm';
import LoginForm from './components/Shared/authforms/LoginForm';
import { Box, Typography, Paper, Button, Stack, ThemeProvider } from '@mui/material';
import { useTranslation } from 'react-i18next';
// import { tenantId } from './globals_VITE';
import AdvertsView from './pages/adverts/AdvertsView';
import LanguageSwitcher from './components/Shared/LanguageSwitcher';
import PasswordResetForm from './components/Shared/authforms/PasswordResetForm';
import { useAuth } from './hooks/useAuth';
// import ThemeSwitcher from './components/Shared/ThemeSwitcher';
// import { sendResetPasswdEmail } from './api/updateUser';

interface AppNewbieProps {
  appTitle: string;
}

const AppNewbie: React.FC<AppNewbieProps> = ({ appTitle }) => {
  const { t } = useTranslation();
  const [showLogin, setShowLogin] = useState(true);
  const toggleForm = () => {
    setShowLogin(!showLogin);
  };

  const navigate = useNavigate();
  const auth = useAuth();

  return (
    <Box
      display="flex"
      flexDirection="column"
      alignItems="center"
      justifyContent="center"
      minHeight="100vh"
      bgcolor="grey.100"
      padding={2}
    >
      <Paper
        elevation={3}
        sx={{
          padding: 4,
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          maxWidth: 400,
          width: '100%',
        }}
      >
        <Typography variant="h4" component="h1" gutterBottom sx={{ fontWeight: 'bold', color: 'primary.main' }}>
          {appTitle}
        </Typography>
        <Routes>
          <Route path="/adveert" element={<><AdvertsView /></>}/>
          {/* <Route path="/resetPasswd" element={<PasswordResetForm />} /> */}
          <Route path="/login" element={
            <>
              <Stack direction="row" spacing={2} sx={{ marginBottom: 0, marginTop: 0 }}>
                  <div style={{ marginBottom: 20, marginTop: 20 }}>
                      <LanguageSwitcher sx={{ minWidth: 120 }} /> 
                  </div>          
                    {/* <div style={{ marginBottom: 20, marginTop: 20 }}>
                        <ThemeSwitcher sx={{ minWidth: 120 }} />
                    </div> */}
              </Stack>

              {showLogin ? <LoginForm onSuccess={() => navigate('/dashboard')}/> 
                         : <SignupForm onSuccess={() => { setShowLogin(true); navigate('/login')} }/>}

              <Button onClick={toggleForm} sx={{ marginTop: '10px' }}>
                { showLogin ? t('Registration') : t('Sign In')}
              </Button>

              <Button onClick={() => navigate('/reset')} sx={{ marginTop: '10px' }}>
                {t('Forgot Password')}
              </Button>
              {/* Optionally add a link to the reset form */}
              {/* <Link to="/reset">Forgot Password?</Link> */}
            </>
          } />
          {/* <Route path="/login" element={<LoginForm />} /> */}
          <Route path="/signup" element={<SignupForm />} />
          
          <Route path="/reset" element={<PasswordResetForm onSubmit={async (email) => { 
            await auth.resetPassword(email); 
            alert('Письмо с инструкциями отправлено на вашу почту!');
            navigate('/login'); 
          }}/>} />
          
          {/* Если пользователь не аутентифицирован и пытается перейти по другому пути,
              перенаправляем его на страницу входа.
              Это особенно полезно, если AppNewbie рендерится для всех путей,
              когда пользователь не вошел в систему. */}
          <Route path="*" element={<Navigate to="/login" replace />} />
        </Routes>
      </Paper>
      <Typography variant="caption" sx={{ mt: 2, color: 'text.secondary' }}>
        © {new Date().getFullYear()} {appTitle}. Всі права захищено.
      </Typography>
    </Box>
  );
};

export default AppNewbie;